import { createSelector } from "reselect";
import _ from "lodash";

const getEquipments = state => state.equipmentReducer.equipments;

export const getSystemEquipments = createSelector(
  [getEquipments],
  equipments => _.pickBy(equipments, equipment => equipment.system)
);
